import styled from 'styled-components';
import { GapInput } from '../../common/specificPropInputs/containerProps/GapInput';
import { MarginInput } from '../../common/specificPropInputs/containerProps/MarginInput';
import { OverflowInput } from '../../common/specificPropInputs/containerProps/OverflowInput';
import { PaddingInput } from '../../common/specificPropInputs/containerProps/PaddingInput';
import { PositionInput } from '../../common/specificPropInputs/containerProps/PositionInput';
import { PositioningInput } from '../../common/specificPropInputs/containerProps/PositioningInput';
import { PositioningSimplifiedInput } from '../../common/specificPropInputs/containerProps/PositioningSimplifiedInput';
import { SizeInput } from '../../common/specificPropInputs/containerProps/SizeInput';
import { useScene } from '../../../context/sceneContext';

export const ContainerPropsPanel = () => {
  const scene = useScene();
  const inputs = scene.getSelectedElementsPropInputs();

  const underSeparatorInputs = ['positioningInput', 'paddingInput', 'marginInput', 'gapInput', 'overflowInput'];
  const isSeparatorVisible = inputs.some((input) => underSeparatorInputs.includes(input));

  return (
    <Container>
      {inputs.includes('positionInput') && <PositionInput />}
      {inputs.includes('sizeInput') && <SizeInput />}

      {isSeparatorVisible && <Separator />}

      {inputs.includes('positioningInput') ? (
        <PositioningInput />
      ) : (
        inputs.includes('positioningSimplifiedInput') && <PositioningSimplifiedInput />
      )}

      <Row>
        {inputs.includes('paddingInput') && <PaddingInput />}
        {inputs.includes('marginInput') && <MarginInput />}
        {inputs.includes('gapInput') && <GapInput />}
      </Row>

      {inputs.includes('overflowInput') && <OverflowInput />}
    </Container>
  );
};

const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 5px 0;

  background-color: var(--neutral-3);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
`;

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;
